import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import UpIcon from "@mui/icons-material/ArrowUpwardOutlined";
import DownIcon from "@mui/icons-material/ArrowDownwardOutlined";
import {
  Box,
  Tooltip,
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Popover,
  Icon,
  Badge,
  Skeleton,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import DeleteConfirmationModal from "../deleteConfirmationModal";
import { isMobile } from "../../globalStyles/mobile";
import SupplierDetailsModal from "../supplier-details-modal";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SortingIcon from "../../globalStyles/icons/sorting-icon";
import FilterModal from "../filterModal";
import { useTheme } from "@mui/styles";
import ViewIcon from "../../globalStyles/icons/vieewIcon";
import EditIcon from "../../globalStyles/icons/editIcon";
import TableHeader from "../table-header";
import { useDarkMode } from "../context/darkModeContext";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#EEEEEE",
    padding: "6px",
    textAlign: "start",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "4px",
    textAlign: "start",
  },
}));

const StyledTableRow = styled(TableRow)(({}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--row-bg-odd)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "var(--row-bg-even)",
    border: "1px solid var(--border-color)",
  },

  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));

const SupplierTableCell = ({
  supplier,
  handleViewClick,
  handleEditClick,
  clientId,
  colors,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const handleActionClick = (action) => {
    handlePopoverClose();
    switch (action) {
      case "view":
        handleViewClick(supplier);
        break;
      case "edit":
        handleEditClick(supplier);
        break;
      // case "delete":
      //   handleDeleteClick(supplier);
      // break;
      default:
        break;
    }
  };

  return (
    <Box>
      <IconButton
        aria-label="more actions"
        onClick={handlePopoverOpen}
        sx={{
          color: open ? "primary.main" : "inherit",
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", padding: 1 }}>
          <Button
            onClick={() => handleActionClick("view")}
            sx={{ textTransform: "none", justifyContent: "flex-start" }}
          >
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <ViewIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={colors.textSecondary}
                fontWeight={500}
              >
                View
              </Typography>
            </Box>
          </Button>
          {clientId ? (
            <></>
          ) : (
            <Button
              onClick={() => handleActionClick("edit")}
              sx={{ textTransform: "none", justifyContent: "flex-start" }}
            >
              <Box display={"flex"} gap={1} alignItems={"center"}>
                <EditIcon />
                <Typography
                  fontFamily={"poppins"}
                  fontSize={"16px"}
                  color={colors.textSecondary}
                  fontWeight={500}
                >
                  Edit
                </Typography>
              </Box>
            </Button>
          )}
          {/* <IconButton
            onClick={() => handleActionClick("delete")}
            title="Delete"
          >
            <DeleteIcon />
          </IconButton> */}
        </Box>
      </Popover>
    </Box>
  );
};
const SupplierList = ({
  client,
  data,
  onEditData,
  onDeleteData,
  handleDeleteClient,
  viewMode,
  selectedSupplier,
  setSelectedSupplier,
  onChangeFilter,
  filterData,
  currentPage,
  itemsPerPage,
  clientId,
  loading,
  setLoading,
}) => {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedSupplierData, setSelectedSupplierData] = useState([]);
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [selectedFilterKey, setSelectedFilterKey] = useState("");
  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const { colors } = useDarkMode();
  const [selectedfilterData, setSelectedFilterData] = useState({
    key: "",
    name: "",
    filter: [],
    sort: 0,
    id: "_id",
    displayKey: "name",
    fetchApi: () => {},
    options: [],
    loadMoreButton: false,
    searchKey: "",
  });
  const startIndex = currentPage * itemsPerPage;
  const handleOpenFilter = (event, filterKey) => {
    setAnchorElFilter(event.currentTarget);
    setSelectedFilterKey(filterKey);
    setOpenFilterModal(true);
    setSelectedFilterData(
      filterData?.columns.find((x) => x?.key === filterKey),
    );
  };
  const handleSaveFilter = (
    selectedOptions,
    filterKey,
    sortOrder,
    searchKey,
  ) => {
    onChangeFilter({
      key: filterKey,
      filter: selectedOptions,
      sort: sortOrder,
      searchKey: searchKey,
    });
    handleCloseFilter();
  };

  const handleCloseFilter = () => {
    setAnchorElFilter(null);
    setOpenFilterModal(false);
  };

  const confirmDelete = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      onDeleteData && onDeleteData();
      setOpenConfirmation(false);
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewClick = (supplier) => {
    setSelectedSupplier(supplier);
    setOpenViewModal(true);
  };
  useEffect(() => {
    setSelectedSupplierData(
      data?.map((supplier) => ({
        ...supplier,
        action: (
          <SupplierTableCell
            supplier={supplier}
            handleViewClick={handleViewClick}
            handleEditClick={onEditData}
            clientId={clientId}
            colors={colors}
            //handleDeleteClick={handleDeleteClick}
          />
        ),
      })),
    );
  }, [data]);

  const getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  };
  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_product.png"
        alt="No data available"
        style={{ objectFit: "cover", height: "300px" }}
      />
    </div>
  );
  const renderGridView = () => (
    <Grid
      sx={{
        marginTop: "1px",
        maxHeight: "100%",
        paddingBottom: 5,
        overflow: "auto",
      }}
      container
      spacing={2}
    >
      {selectedSupplierData?.map((supplier, index) => (
        <Grid sx={{ paddingBottom: 1 }} item xs={12} sm={6} md={4} key={index}>
          <Card
            sx={{
              boxShadow: 3,
              cursor: "pointer",
              width: "100%",
              height: "100%",
              position: "relative",
              borderRadius: "6px",
              border: `1px solid ${colors.borderLight}`,
            }}
          >
            <CardContent>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  fontWeight="500"
                  sx={{ textAlign: "start" }}
                  fontFamily="Poppins"
                  color="#333333"
                >
                  {startIndex + index + 1}
                </Typography>
                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                  }}
                >
                  {supplier?.action}
                </div>
              </div>
              <Grid container spacing={1} mt={2}>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color={colors.textSecondary}
                  >
                    Name
                  </Typography>

                  {filterData.columns.find((x) => x.key === "name")?.sort ===
                  1 ? (
                    <Icon sx={{ display: "flex", alignItems: "center" }}>
                      <UpIcon color="disabled" />
                    </Icon>
                  ) : filterData.columns.find((x) => x.key === "name")?.sort ===
                    -1 ? (
                    <Icon sx={{ display: "flex", alignItems: "center" }}>
                      <DownIcon color="disabled" />
                    </Icon>
                  ) : null}
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={colors.textSecondary}
                  >
                    : {supplier?.name}
                  </Typography>
                </Grid>

                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={colors.textSecondary}
                  >
                    Email
                  </Typography>
                  {filterData.columns.find((x) => x.key === "email")?.sort ===
                  1 ? (
                    <Icon sx={{ display: "flex", alignItems: "center" }}>
                      <UpIcon color="disabled" />
                    </Icon>
                  ) : filterData.columns.find((x) => x.key === "email")
                      ?.sort === -1 ? (
                    <Icon sx={{ display: "flex", alignItems: "center" }}>
                      <DownIcon color="disabled" />
                    </Icon>
                  ) : null}
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={colors.textSecondary}
                  >
                    : {supplier?.email}
                  </Typography>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={colors.textSecondary}
                  >
                    Address 1
                  </Typography>
                  {filterData.columns.find((x) => x.key === "address.address1")
                    ?.sort === 1 ? (
                    <Icon sx={{ display: "flex", alignItems: "center" }}>
                      <UpIcon color="disabled" />
                    </Icon>
                  ) : filterData.columns.find(
                      (x) => x.key === "address.address1",
                    )?.sort === -1 ? (
                    <Icon sx={{ display: "flex", alignItems: "center" }}>
                      <DownIcon color="disabled" />
                    </Icon>
                  ) : null}
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={colors.textSecondary}
                  >
                    :{supplier?.address?.address1}
                  </Typography>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={colors.textSecondary}
                  >
                    City
                  </Typography>
                  {filterData.columns.find((x) => x.key === "address.city")
                    ?.sort === 1 ? (
                    <Icon sx={{ display: "flex", alignItems: "center" }}>
                      <UpIcon color="disabled" />
                    </Icon>
                  ) : filterData.columns.find((x) => x.key === "address.city")
                      ?.sort === -1 ? (
                    <Icon sx={{ display: "flex", alignItems: "center" }}>
                      <DownIcon color="disabled" />
                    </Icon>
                  ) : null}
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={colors.textSecondary}
                  >
                    : {supplier?.address?.city}
                  </Typography>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={colors.textSecondary}
                  >
                    Province
                  </Typography>
                  {filterData.columns.find((x) => x.key === "address.province")
                    ?.sort === 1 ? (
                    <Icon sx={{ display: "flex", alignItems: "center" }}>
                      <UpIcon color="disabled" />
                    </Icon>
                  ) : filterData.columns.find(
                      (x) => x.key === "address.province",
                    )?.sort === -1 ? (
                    <Icon sx={{ display: "flex", alignItems: "center" }}>
                      <DownIcon color="disabled" />
                    </Icon>
                  ) : null}
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={colors.textSecondary}
                  >
                    : {supplier?.address?.province}
                  </Typography>
                </Grid>

                <Grid item xs={5} display={"flex"} alignContent={"center "}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={colors.textSecondary}
                  >
                    Country
                  </Typography>
                  {filterData.columns.find((x) => x.key === "address.country")
                    ?.sort === 1 ? (
                    <Icon sx={{ display: "flex", alignItems: "center" }}>
                      <UpIcon color="disabled" />
                    </Icon>
                  ) : filterData.columns.find(
                      (x) => x.key === "address.country",
                    )?.sort === -1 ? (
                    <Icon sx={{ display: "flex", alignItems: "center" }}>
                      <DownIcon color="disabled" />
                    </Icon>
                  ) : null}
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={colors.textSecondary}
                  >
                    : {supplier?.address?.country}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const TableSchema = [
    {
      key: "sl_no",
      title: "SL NO",
      render: (item, index) => (
        <Typography
          fontSize="12px"
          color={colors.textSecondary}
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {startIndex + index + 1}
        </Typography>
      ),
    },
    {
      key: "name",
      title: "NAME",
      filterKey: "name",
      handleOpenFilter: handleOpenFilter,
      displayKey: "name",
    },
    {
      key: "email",
      title: "EMAIL",
      filterKey: "email",
      handleOpenFilter: handleOpenFilter,
      displayKey: "email",
    },
    {
      key: "address.address1",
      title: "ADDRESS 1",
      displayKey: "address.address1",
    },
    {
      key: "address.city",
      title: "CITY",
      filterKey: "address.city",
      handleOpenFilter: handleOpenFilter,
      render: (item) => (
        <Typography
          fontSize="12px"
          color={colors.textSecondary}
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {item?.address?.city || "--"}
        </Typography>
      ),
    },
    {
      key: "address.province",
      title: "PROVINCE",
      width: "15%",
      filterKey: "address.province",
      handleOpenFilter: handleOpenFilter,
      render: (item) => (
        <Typography
          fontSize="12px"
          color={colors.textSecondary}
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {item?.address?.province || "--"}
        </Typography>
      ),
    },
    {
      key: "address.country",
      title: "COUNTRY",
      width: "15%",
      filterKey: "address.country",
      handleOpenFilter: handleOpenFilter,
      render: (item) => (
        <Typography
          fontSize="12px"
          color={colors.textSecondary}
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {item?.address?.country || "--"}
        </Typography>
      ),
    },
    ...(clientId
      ? []
      : [{ key: "action", title: "", width: "3%", displayKey: "action" }]),
  ];

  const renderListView = (loading) => (
    <div
      style={{
        width: "100%",
        overflow: isMobile() ? "auto" : "hidden",
        paddingBottom: 20,
        marginTop: 5,
      }}
    >
      {isMobile() ? (
        renderGridView()
      ) : (
        <TableContainer
          sx={{
            overflowY: "auto",
            paddingInline: 0.4,
            maxHeight: "100%",
            background: colors.bgPaper,
            border: `1px solid ${colors.border}`,
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              border: `1px solid ${colors.border}`,
              background: colors.bgPaper,
              border: `1px solid ${colors.border}`,
            }}
          >
            <TableHead
              sx={{
                backgroundColor: `${colors.background} !important`,
                "& th": { backgroundColor: `${colors.background}` },
              }}
            >
              <StyledTableRow>
                {TableSchema.map((column) => (
                  <TableHeader
                    key={column.key}
                    column={column}
                    filterData={filterData}
                    filterKey={column.filterKey}
                    handleOpenFilter={column.handleOpenFilter}
                    title={column.title}
                  />
                ))}
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                [...Array(15)].map((_, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {[...Array(TableSchema.length)].map((_, colIndex) => (
                      <TableCell key={colIndex} sx={{ p: 2 }}>
                        <Skeleton variant="text" />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : selectedSupplierData.length === 0 ? (
                <StyledTableRow>
                  <TableCell colSpan={8} align="center">
                    <NoDataImage />
                  </TableCell>
                </StyledTableRow>
              ) : (
                selectedSupplierData?.map((x, rowIndex) => (
                  <StyledTableRow
                    sx={{
                      "&:hover": { backgroundColor: `var(--row-hover-bg)` },
                      height: 48,
                    }}
                    key={rowIndex}
                  >
                    {TableSchema.map((column, colIndex) => (
                      <StyledTableCell
                        key={column.key || colIndex}
                        sx={{ width: column.width }}
                      >
                        {column.displayKey ? (
                          <Typography
                            fontSize="12px"
                            color={colors.textSecondary}
                            fontWeight={400}
                            fontFamily={"Poppins"}
                          >
                            {getNestedValue(x, column.displayKey) || "--"}
                          </Typography>
                        ) : column.render ? (
                          column.render(x, rowIndex)
                        ) : (
                          "--"
                        )}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );

  return (
    <div sx={{ minWidth: "100%" }}>
      <div
        style={{
          overflowY: "scroll",
          display: "flex",
          maxHeight: isMobile() ? `calc(100vh - 210px)` : `calc(100vh - 190px)`,
          width: "100%",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::WebkitScrollbar": { width: 0 },
        }}
      >
        {viewMode === "grid" ? renderGridView() : renderListView(loading)}
      </div>
      <Popover
        open={Boolean(anchorElFilter)}
        anchorEl={anchorElFilter}
        onClose={handleCloseFilter}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        disableScrollLock={true}
      >
        <FilterModal
          open={openFilterModal}
          onClose={handleCloseFilter}
          options={selectedfilterData?.options}
          selectedValues={selectedfilterData?.filter}
          onSave={handleSaveFilter}
          currentSortOrder={selectedfilterData?.sort}
          filterKey={selectedFilterKey}
          hasMore={selectedfilterData?.loadMoreButton}
          displayKey={selectedfilterData?.displayKey}
          id={selectedfilterData?.id}
          fetchApi={selectedfilterData?.fetchApi}
          searchKey={selectedfilterData?.searchKey}
        />
      </Popover>
      <DeleteConfirmationModal
        DeleteConfirmationModal
        title={`Are you sure you want to delete ${selectedSupplier?.name} ?`}
        open={openConfirmation}
        handleClose={() => setOpenConfirmation(false)}
        handleDelete={(e) => {
          if (client) {
            handleDeleteClient && handleDeleteClient(selectedSupplier);
            setOpenConfirmation(false);
          } else {
            confirmDelete(e);
          }
        }}
      />

      <SupplierDetailsModal
        supplier={selectedSupplier}
        open={openViewModal}
        onClose={() => setOpenViewModal(false)}
      />
    </div>
  );
};

export default SupplierList;
